import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "styled-components";
import { PrimeReactProvider } from "primereact/api";
import AppRoutes from "./routes";
import { AuthProvider } from "./context/AuthContext";
import {
  ThemeModeProvider,
  useThemeMode,
} from "./context/ThemeModeContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { theme } from "./styles/theme";
import GlobalStyles from "./global/styles";

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./styles/theme.tokens.css";
import "./styles/dialog.overrides.css";
import "./styles/primeReactOverrides.css";
import { APIProvider } from "@vis.gl/react-google-maps";
import { initAnalytics } from "./utils/analytics";

initAnalytics();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: 1,
      staleTime: 1000 * 60 * 5,
    },
  },
});

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

function ThemedToastContainer() {
  const { resolved } = useThemeMode();
  return <ToastContainer position="top-right" autoClose={5000} theme={resolved} />;
}

function App() {
  return (
    <PrimeReactProvider
      value={{ hideOverlaysOnDocumentScrolling: false }}
    >
      <QueryClientProvider client={queryClient}>
        <ThemeModeProvider>
          <ThemeProvider theme={theme}>
            <GlobalStyles />
            <APIProvider apiKey={API_KEY}>
              <AuthProvider>
                <ThemedToastContainer />
                <AppRoutes />
              </AuthProvider>
              <ReactQueryDevtools initialIsOpen={false} />
            </APIProvider>
          </ThemeProvider>
        </ThemeModeProvider>
      </QueryClientProvider>
    </PrimeReactProvider>
  );
}

export default App;
